export const LOAD_STANDS = 'LOAD_STANDS'